import { Injectable } from '@angular/core';
import { RutInformation } from 'src/app/global/interfaces/rut-formatter/rut-information';
import { RutFormatterService } from 'src/app/view-model/services/rut-formatter.service';

@Injectable()
export class RutFormatterProvider extends RutFormatterService {

  public getRutFormats(rut: string): RutInformation {
    rut = rut.replace(/\./g, '');
    rut = rut.replace(/-/g, '');

    const numbers: string = rut.substring(0, rut.length - 1);
    const dv: string = rut.slice(-1);
    const dvMod: string = dv.toUpperCase();
    let dvFinal: string;
    let bareFinal: string;
    if (Number.isInteger(Number(dv))) {
      dvFinal = dv;
    } else {
      dvFinal = dvMod;
    }
    if (Number.isInteger(Number(dv))) {
      bareFinal = numbers + dv;
    } else {
      bareFinal = numbers + dvMod;
    }

    const numbersAsInt = parseInt(numbers);
    return {
      numbers: numbersAsInt,
      validator: dvFinal,
      simple: numbers + '-' + dv,
      bare: bareFinal,
      full: (Number(numbers).toLocaleString('en') + '-' + dv).replace(/,/g, '.')
    };
  }

  getDv(T: number): string | number {
    let M = 0, S = 1;
	   for (; T; T = Math.floor(T / 10)) {
      const aux = M++;
      S = (S + (T % 10) * (9 - (aux % 6))) % 11;
    }
	   return S ? S - 1 : 'k';
  }

  format(value: string): string {
    if (value.replace(/[^kK0-9]/g, '').length > 9) {
      value = value.replace(/[^kK0-9]/g, '').slice(0, 9);
    }

    if (value.length < 8) {
      if (value.endsWith('k') || value.endsWith('K')) {
        value = value.replace(/[kK]/g, '');
      }
    } else {
      const chars = value.split('');
      let charCounter = 0;
      for (const char of chars) {
        if (char === 'k' || char === 'K') {
          charCounter++;
        }
      }

      if (charCounter > 1) {
        value = value.slice(0, value.length - 1);
      } else if (charCounter === 1) {
        if (!value.endsWith('k') && !value.endsWith('K')) {
          value = value.slice(0, value.length - 1);
        }
      }
    }
    return value
      .replace(/[^kK0-9]/g, '')
      .replace(/^(\d{1,2})(\d{3})(\d{3})(\w{1})$/, '$1.$2.$3-$4');
  }
}
